export const CO2_KG_PER_NOTEBOOK = 282;
export const CO2_KG_PER_ALL_IN_ONE = 472.7;
export const CO2_KG_PER_DESKTOP = 471.8;
export const CO2_KG_PER_MONITOR = 522;
export const CO2_KG_PER_TABLET = 141.1;
export const CO2_KG_PER_SMARTPHONE = 55.4;
export const CO2_KG_PER_PERIPHERAL_DEVICE = 22.3;

export const CONVERSION_FLIGHT_KM_PER_KG_CO2 = 2.6102;  // 1 kg CO2 ≈ 1.6219 miles
export const CONVERSION_VIDEOCONFERENCE_HOURS_PER_KG_CO2 = 1; // Up to 1000g CO2 for one hour of videoconferencing according to https://news.mit.edu/2021/how-to-reduce-environmental-impact-next-virtual-meeting-0304#:~:text=One%20hour%20of%20str[…]0one%20gallon%20of%20gasoline
export const CONVERSION_ESPRESSO_PER_KG_CO2 = 3.5714285714; // 0.28 kg CO2 per espresso according to https://www.ucl.ac.uk/news/2021/jan/analysis-heres-carbon-cost-your-daily-coffee-and-how-make-it-climate-friendly

export const COUNTER_DURATION_SEC = 0.5;



// WEBPACK FOOTER //
// ./src/calculationParams.js